import {Identifiable} from "./identifiable";
import {ArrayUtils} from "./arrayUtils";

export function getByKey<T extends Identifiable>(entries: T[], id: number) {
    return ArrayUtils.getBy(entries, e => e.id === id);
}
